export default __webpack_public_path__ + "static/media/35g.ed65f479.svg";